// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Je","subtitle":"Ke","contentWrap":"Le","imgWrap":"Me","heading":"Ne","copy":"Oe"};